import { useMenu } from "hook/useMenu";
import { Navigate } from "react-router-dom";

export default function KeysEntry() {
  const { buildEntryNavigateProps } = useMenu({});

  return (
    <Navigate
      {...buildEntryNavigateProps("/subscription/keys/organization")}
      replace
    />
  );
}
